import StyleSettingMixin from "@/components/palette/settings/style/types/StyleSettingMixin";
export default {
    name: "UnknownStyleSetting",
    mixins: [StyleSettingMixin],
    data() {
        return {};
    }
};
